import { render, staticRenderFns } from "./solicitudes-bodega-movil.vue?vue&type=template&id=04c0ef80"
import script from "./solicitudes-bodega-movil.vue?vue&type=script&lang=js"
export * from "./solicitudes-bodega-movil.vue?vue&type=script&lang=js"
import style0 from "./solicitudes-bodega-movil.vue?vue&type=style&index=0&id=04c0ef80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports